import { createContext, useContext } from "react";

type OrderStatusPageContextResults = {
  selectedOrderId?: string;
};

export const OrderStatusPageContext =
  createContext<OrderStatusPageContextResults>(
    {} as OrderStatusPageContextResults,
  );

export const useOrderStatusPageContext = () =>
  useContext(OrderStatusPageContext);
